import { ZEN_API_DEV_PROXY_PATH } from './zen-api-dev-proxy';

const configuredBaseUrl =
  import.meta.env.VITE_ZENAPI_BASE_URL ||
  'https://api.prod.mentoralift.ai/api/v1';

/**
 * In `vite dev`, route API calls through the same-origin dev proxy so the
 * session cookie is first-party (Safari/WebKit block third-party cookies).
 */
function toDevProxyUrl(url: string): string {
  const { pathname } = new URL(url);
  return `${ZEN_API_DEV_PROXY_PATH}${pathname.replace(/\/$/, '')}`;
}

export const ZEN_API_BASE_URL = import.meta.env.DEV
  ? toDevProxyUrl(configuredBaseUrl)
  : configuredBaseUrl;

export function getZenApiWsBaseUrl(): string {
  const configured = import.meta.env.VITE_ZENAPI_BASE_WS_URL;
  if (!import.meta.env.DEV || !configured) {
    return configured;
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${toDevProxyUrl(configured)}`;
}
